import { DocumentCreatorProps } from '@/components/document/DocumentCreator.types'
import { useEffect, useState } from 'react'
import { ClickEvent } from 'devextreme/ui/button'
import { Get as MgtGet, MgtTemplateProps, File as MgtFile } from '@microsoft/mgt-react'
import { Button, LoadIndicator } from 'devextreme-react'
import { DocumentPermissions } from '@/enums'

const DocumentCreator = (props: DocumentCreatorProps) => {
  const { title, documentUrl, documentGetRef, readOnly, action, preliminarPermissionsAction } = props
  const [permissions, setPermissions] = useState<DocumentPermissions>()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    const computePermissions = async () => {
      let objperm: DocumentPermissions = DocumentPermissions.Deny
      if (preliminarPermissionsAction) {
        objperm = await preliminarPermissionsAction()
      }
      if (cancelled) return
      setPermissions(objperm)
      setIsLoading(false)
    }

    computePermissions()
    return () => {
      cancelled = true
    }
  }, [documentUrl])

  if (isLoading) {
    return <LoadIndicator id="small-indicator" height={20} width={20} />
  }

  const MgtFileCustom = (props: MgtTemplateProps) => {
    const data = props.dataContext
    if (permissions && permissions !== DocumentPermissions.Deny) {
      return (
        <MgtFile
          onClick={async (event) => {
            window.open(data.webUrl, '_blank')
          }}
          driveId={import.meta.env.VITE_QSADMINSITE_DRIVE_ID}
          itemId={data.id}
          fileDetails={{ lastModifiedDateTime: data.lastModifiedDateTime, name: data.name }}
        ></MgtFile>
      )
    }

    return <div>Non si dispone dei permessi di accesso necessari. Contattare un amministratore per informazioni</div>
  }

  const MgtFileLoading = (props: MgtTemplateProps) => {
    return <LoadIndicator id="small-indicator" height={20} width={20} />
  }

  const MgtFileError = (props: MgtTemplateProps) => {
    return <div>Impossibile individuare il documento</div>
  }

  const MgtFileNoData = (props: MgtTemplateProps) => {
    const [createDocLoadIndicatorVisible, setCreateDocLoadIndicatorVisible] = useState(false)

    if (permissions && permissions !== DocumentPermissions.Deny) {
      return readOnly ? (
        <div>Nessun documento caricato</div>
      ) : (
        <Button
          disabled={permissions === DocumentPermissions.Read}
          stylingMode="outlined"
          type="default"
          width={180}
          height={40}
          onClick={async (e: ClickEvent) => {
            setCreateDocLoadIndicatorVisible(true)

            try {
              await action()
            } finally {
              setCreateDocLoadIndicatorVisible(false)
              documentGetRef.current?.refresh(true)
            }
          }}
        >
          <LoadIndicator className="button-indicator" visible={createDocLoadIndicatorVisible} />
          <span className="dx-button-text">{createDocLoadIndicatorVisible ? 'In creazione...' : `Crea ${title}`}</span>
        </Button>
      )
    } else {
      return <div>Non si dispone dei permessi di accesso necessari. Contattare un amministratore per informazioni</div>
    }
  }

  return (
    <>
      <MgtGet
        ref={documentGetRef}
        resource={`drives/${import.meta.env.VITE_QSADMINSITE_DRIVE_ID}/root:/${documentUrl}`}
      >
        <MgtFileCustom template="default" />
        <MgtFileLoading template="loading" />
        <MgtFileNoData template="no-data" />
        <MgtFileError template="error" />
      </MgtGet>
    </>
  )
}

export default DocumentCreator
